import { ActionCreators } from 'redux-undo';
import { BaseApi } from "../shared/api";
import * as types from "./actionTypes";
import * as sharedTypes from "../shared/actionTypes";
import * as url from "./apiWrappers";

// remove on phase 7
import Cookies from "universal-cookie";
import * as apiUrls from "./apiUrls";
const cookies = new Cookies();

const fetchTradeDocumentsSuccess = (payload) => ({
  type: types.TRADE_DOCUMENTS_FETCH_SUCCESS,
  payload: payload
});

export function fetchTradeDocuments(docType) {
  return (dispatch, getState) => {
    dispatch({type: sharedTypes.LOADING_START})

    const filterIndex = getState().tradeDocuments.index + 1;
    const api = new BaseApi(dispatch, getState);
    return api.getRequest(
      url.tradeDocuments(docType),
      response => {
        dispatch(fetchTradeDocumentsSuccess({data: response.data, docType: docType, filterIndex: filterIndex}))
      }
    )
  }
}

export function filterTradeDocuments(filter, docType) {
  return (dispatch, getState) => {
    dispatch(ActionCreators.jumpToPast(getState().tradeDocuments.present.defaultFilterIndex));
    dispatch({type: types.TRADE_DOCUMENTS_FILTER, payload: {filter: filter, docType: docType}});
  }
}

// TODO: Fix me on phase 7
export function fetchUserTradeDocument(
    userID,
    tradeDocumentType,
    id,
    loadingCallback,
  ) {
  return (dispatch) => {
    return fetch(apiUrls.userTradeDocument(
      userID,
      tradeDocumentType,
      id
    ), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken")
      }),
    })
    .then(response => response.json())
    .then(json => {
        if (loadingCallback) loadingCallback();
        return dispatch(receiveTradeDocument(json))
    });
  };
}

export function receiveTradeDocument(json) {
  return {type: types.RECEIVE_USER_TRADE_DOCUMENT, payload: json};
}

export function updateTradeDocument(
  userID,
  tradeDocumentType,
  tradeDocumentID,
  body,
) {
  return fetch(apiUrls.userTradeDocument(
    userID,
    tradeDocumentType,
    tradeDocumentID,
  ), {
    method: "PUT",
    headers: new Headers({
      "Authorization": cookies.get("jwtToken"),
    }),
    body,
  })
}

export function deleteTradeDocument(
  userID,
  tradeDocumentType,
  tradeDocumentID,
) {
  return fetch(apiUrls.userTradeDocument(
    userID,
    tradeDocumentType,
    tradeDocumentID,
  ), {
    method: "DELETE",
    headers: new Headers({
      "Authorization": cookies.get("jwtToken"),
    }),
  })
}

export const fetchFcaTradeDocuments = (loadingCallback, withDraft = false, page = 1) => {
  return ( dispatch, getState ) => {
    const api = new BaseApi(dispatch, getState);

    return api.getRequest(
      apiUrls.tradeDocumentsURL(withDraft, page),
      response => {
        dispatch(receiveTradeDocuments(response.data));
        loadingCallback();
      });
  };
};

export const receiveTradeDocuments = (data) => {
  return { type: types.RECEIVE_TRADE_DOCUMENTS, payload: data }
};

export const resetFcaTradeDocuments = () => {
  return { type: types.RESET_TRADE_DOCUMENTS }
}



// WEBPACK FOOTER //
// ./src/features/trade_documents/actions.js